import type { ReactNode } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { useAuth } from '../auth/useAuth';
import { useCan } from '../auth/AuthProvider';

const navLinkClass = ({ isActive }: { isActive: boolean }) =>
  `border-b-2 py-4 text-sm transition-colors ${
    isActive ? 'border-brand font-medium text-white' : 'border-transparent text-white/60 hover:text-white'
  }`;

export function AppShell({ children }: { children: ReactNode }) {
  const { user, roles, status } = useAuth();
  const signedInWithRole = status === 'signed-in' && roles.length > 0;
  const canManage = useCan('settings.manage');
  return (
    <div className="min-h-screen">
      <header className="bg-brand-ink">
        <div className="mx-auto flex max-w-6xl items-center justify-between px-6">
          <div className="flex items-center gap-6">
            {/* Wordmark follows the másLabor logo: red "más", white remainder */}
            <Link to="/" className="py-3 font-display text-lg font-extrabold tracking-tight">
              <span className="text-brand">más</span>
              <span className="text-white">Flow</span>
            </Link>
            {signedInWithRole && (
              <nav className="flex items-center gap-5">
                <NavLink to="/portfolio" className={navLinkClass}>
                  Kanban
                </NavLink>
                <NavLink to="/table" className={navLinkClass}>
                  Table
                </NavLink>
                <NavLink to="/dashboard" className={navLinkClass}>
                  Dashboard
                </NavLink>
                <NavLink to="/anchors" className={navLinkClass}>
                  Anchors
                </NavLink>
                <NavLink to="/help" className={navLinkClass}>
                  Help
                </NavLink>
                {canManage && (
                  <NavLink to="/admin/categories" className={navLinkClass}>
                    Admin
                  </NavLink>
                )}
              </nav>
            )}
          </div>
          <div className="text-sm text-white/50">{user?.userDetails ?? 'signed out'}</div>
        </div>
      </header>
      <main className="mx-auto max-w-6xl px-6 py-8">{children}</main>
    </div>
  );
}
